/**************
 Product Swiper
 **************/

// options for all swipers
const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    zoom: {
        maxRatio: 2,
    },
    on: {
        slideChange: function () {
            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
};

// check if there are multiple first
const multipleSwipers = document.querySelector("#productVisual.multiple");

// setup product swiper/s
if (multipleSwipers) {
// conditionally add multiple swipers with thumbnail functionality
    document.querySelectorAll('.productVisualSwiper').forEach((element, index) => {
        const productSwiper = new Swiper(element, swiperOptions);

        // update the thumbnail active class
        productSwiper.on('slideChange', function () {
            element.previousElementSibling.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
            element.previousElementSibling.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");
        });

        // // change slide on thumbnail click
        element.previousElementSibling.querySelectorAll(".productVisualThumbsSlide").forEach(el => {
            el.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });
    });

} else {
    // setup single swiper
    const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), swiperOptions);

// change slide on thumbnail click
    document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update the thumbnail active class
    productSwiper.on('slideChange', function () {
        document.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
        document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");
    });
}

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        if (!video) return;

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

/****************
 Product Variants
 ***************/

// select change on sticky ATC
document.querySelector('#productStickyBuyingSelect')?.addEventListener('change', function () {
    document.querySelector(`.productOptionItemValuesLabel input[value="${this.options[this.selectedIndex].textContent}"]`).click();
});

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        inputChanges(element);
    });
})

// update active variant
function updateProduct(soldOut = false) {

    if (product.variants.length > 1) {
        // collect options from inputs
        let options = [];
        document.querySelectorAll(`.productOptionItem`).forEach(group => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    // update variant title
    if (document.querySelector('.productVariantTitle')) document.querySelector('.productVariantTitle').textContent = activeVariant.title;

    // update variant description
    document.querySelector('.productUniqueDescription.active')?.classList.remove('active');
    document.querySelector(`.productUniqueDescription[data-name="${activeVariant.title}"]`)?.classList.add('active');

    // update variant slider images
    const variantTitle = activeVariant.title.split(' ').join('');
    if (multipleSwipers) {
        // hide existing active
        document.querySelector('.productVisualSwiper.active')?.classList.remove('active');
        document.querySelector('.productVisualThumbs.active')?.classList.remove('active');
        // reveal matching media
        document.querySelector(`.productVisualSwiper.${variantTitle}`).classList.add('active');
        document.querySelector(`.productVisualThumbs.${variantTitle}`).classList.add('active');
    }

    // update sticky ATC to same variant
    if (document.querySelector('#productStickyBuyingSelect')) {
        document.querySelector('#productStickyBuyingSelect').value = activeVariant.id;
        document.querySelector('.productStickyTitle.active')?.classList.remove('active');
        document.querySelector(`.productStickyTitle[data-id="${activeVariant.id}"]`).classList.add('active');

    }

    // enable primary atc
    document.querySelector("#productATC").disabled = false;

    // check if the variant is in stock
    // if (activeVariant.available) {
    if (activeVariant.available && !soldOut) {
        document.querySelector("#productATC").classList.remove("soldOut");
        document.querySelector("#productATC").textContent = "Add To Cart";
        document.querySelector("#productStickyATC").disabled = false;
        document.querySelector("#productStickyATC").textContent = `Add To Cart ${price(activeVariant.price)}`;
    } else {
        document.querySelector("#productATC").classList.add("soldOut");
        document.querySelector("#productATC").textContent = "Sold Out - Notify Me When Available";
        document.querySelector("#productStickyATC").disabled = true;
        document.querySelector("#productStickyATC").textContent = "Sold Out";
    }

    // ships on
    document.querySelectorAll(`#productShipsOn span`).forEach(el => el.classList.remove('active'));
    document.querySelector(`#productShipsOn [data-id="${activeVariant.id}"]`)?.classList.add('active');

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// If on a page, update the active variant to mimic the product page
if (document.querySelector('#product').classList.contains('page')) {
    const pageLink = String(window.location.href);
    if (pageLink.includes("variant")) {
        const id = pageLink.split("variant=")[1];
        if (document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"]`)) {
            document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"] input`).checked = true;
            inputChanges(document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"] input`))
        }
    }
} else {
    updateProduct();
}

function inputChanges(element) {
    element.closest('.productOptionItem').querySelectorAll('label.active').forEach(el => {
        el.classList.remove("active");
        el.style.backgroundColor = "transparent";
    });

    // change label to active
    element.closest('label').classList.add("active");
    const color = element.closest('label').dataset.color;
    element.closest('label').style.backgroundColor = `${color}`;
    // change extra points background color, if available
    document.querySelectorAll('.productSubscriptionPointsListItem').forEach(el => {
        el.style.backgroundColor = `${color}`;
        // for max-holloway //
        color === "#b53c34" ? el.style.color = "#fff" : el.style.color = "#000";
    })

    // check if marked sold out via metafield
    let soldOut = element.classList.contains('soldOut');
    updateProduct(soldOut);
}

/**********************
 * Product Subscription
 **********************/

let hasSubscription = !!document.querySelector('#productSubscription');
let subscriptionID = document.querySelector("#productSubscription")?.dataset.subscription;
const subscriptionPrice = document.querySelector("#productSubscription .productBuyingPrice");

// changing from OTP to Subscription
document.querySelectorAll('.productBuyingOption').forEach(el => {
    el.addEventListener('click', function () {
        // handle active
        if (this.classList.contains('active')) return;
        this.closest('#productBuying').querySelector('.productBuyingOption.active')?.classList.remove('active');
        this.classList.add('active');

        // clicking either option resets subscription ID and if one-time is selected subscription is false
        if (this.id === "productOnce") {
            hasSubscription = false;
            document.querySelector('#productShippingDetailsContainer').classList.remove('active');
        } else {
            hasSubscription = true;
            document.querySelector('#productShippingDetailsContainer').classList.add('active');
        }
    })
})

/******************
 * Product Quantity
 ******************/

let quantity = 1;

/******************
 Product Sticky ATC
 ******************/

// listen for product area to scroll off page
window.addEventListener('scroll', () => {
    // compare product section and window
    let productBottom = document.querySelector('#product')?.getBoundingClientRect().bottom;
    if (!productBottom) return;

    let windowTop = window.scrollY;

    if (windowTop - productBottom > 200) {
        // disable for launch
        document.querySelector('#productSticky').classList.add('active');
    } else {
        document.querySelector('#productSticky').classList.remove('active');
    }
})

document.querySelector('#productStickyATC')?.addEventListener('click', async function () {
    // add loading animation
    this.classList.add("loading");

    // get variant id
    let stickyId;
    if (document.querySelector('#productStickyBuyingSelect')) {
        stickyId = document.querySelector('#productStickyBuyingSelect').value;
    } else {
        stickyId = this.dataset.id;
    }

    let formData = {
        items: [{
            quantity: 1,
            id: stickyId
        }]
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/***********
 Product ATC
 ***********/

document.querySelector("#productATC")?.addEventListener("click", async function () {
    // check for out of stock
    if (this.classList.contains("soldOut")) {
        // check email
        let {value: email} = await Swal.fire({
            title: `${product.title} / ${activeVariant.title}`,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        await sendKlaviyoBackInStockRequest(email, activeVariant.id);

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    const goToCart = this.classList.contains('goToCart');

    if (!goToCart && hasSubscription) {
        // clear the cart
        await fetch("/cart/clear.js");
    }

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
            // if subscription is chosen, use active id
            selling_plan: hasSubscription ? subscriptionID : null
        }]
    };

    // if it's a subscription and going straight to cart, add the sample pack
    if (product.handle === "premium-electrolyte-drink-mix" && !goToCart && hasSubscription) {
        formData.items.push({
            quantity: 1,
            id: samplerVariantID
        });
    }

    if (product.handle === "variety-pack-30ct" && !goToCart && hasSubscription && window.enabledPack30) {
        formData.items.push({
            quantity: 1,
            id: samplerVariantID
        });
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    if (hasSubscription && !goToCart) {
        window.location.href = "/checkout";
    } else {
        await openCart();
    }
});

/******
 Other
 *****/

// opens read the label modal
document.querySelector('.productLabelButton')?.addEventListener('click', () => {
    document.querySelector('#productLabelDialog').showModal();
    document.querySelector('body').classList.add('noScroll');
});

// closes read the label modal
function closeProductModal() {
    document.querySelector('#productLabelDialog').close();
    document.querySelector('body').classList.remove('noScroll');
}

document.querySelector('#productLabelDialogExit')?.addEventListener('click', () => {
    closeProductModal()
});

document.querySelector('#productLabelDialog')?.addEventListener('click', function (e) {
    if (e.target === this) {
        closeProductModal()
    }
});

document.querySelector('#productLabelDialog')?.addEventListener('close', () => {
    document.querySelector('body').classList.remove('noScroll');
});

// check if discount code is present
if (Cookies.get("discount_code")) {
    // set the discount code text
    document.querySelector("#couponfield").textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

    // show the discount code element
    document.querySelector("#couponfield").classList.add("active");
}


// scroll to reviews - allow time for page to load
setTimeout(() => {
    document.querySelector('#productReview').addEventListener('click', () => {
        const reviewSection = document.querySelector('.junip-product-review') || document.querySelector('.junip-review-section');
        if (reviewSection) {
            scrollUntilVisible(reviewSection);
        }
    })
}, 2000)

// update review count to have a comma
const reviewCount = document.querySelector("#productReviewCount").dataset.value;
document.querySelector("#productReviewCount").textContent = `(${parseInt(reviewCount).toLocaleString('en-US')})`;